import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import LeadFlow from '../../../../Assets/Images/lead-icon-flow.png';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import collaborativelogo from '../../../../Assets/Images/COLLABORATIVE.png';
import stratrgiclogo from '../../../../Assets/Images/STRATEGIC.png';
import visionarylogo from '../../../../Assets/Images/VISIONARY.png';
import performancelogo from '../../../../Assets/Images/PERFORMANCE.png';
import GroupReportContext from '../../../../Context/GroupReportContext';
import { applyFullTieOrder } from '../../../../utils/quadrantTieOrder';


const LeadershipFlowSecondPreview360 = ({ apiData, fromLeadership = 'COLLABORATIVE', toLeadership = 'STRATEGIC', reportType, pageNumber }) => {

  const { averagePercentagesLeadership, averagePercentagesLeadershipSelf } = useContext(GroupReportContext)

  const SquareWithArrow = ({ scores }) => {
    const topLeft = 'STRATEGIC';
    const topRight = 'PERFORMANCE';
    const bottomLeft = 'VISIONARY';
    const bottomRight = 'COLLABORATIVE';

    const topLeftValue = (scores?.find(s => s.name === 'strategic')?.value || 0).toFixed(2);
    const topRightValue = (scores?.find(s => s.name === 'performance')?.value || 0).toFixed(2);
    const bottomLeftValue = (scores?.find(s => s.name === 'visionary')?.value || 0).toFixed(2);
    const bottomRightValue = (scores?.find(s => s.name === 'collaborative')?.value || 0).toFixed(2);

    const labelStyle = { color: '#000', fontSize: '9px', fontWeight: '700', fontFamily: 'Helvetica, sans-serif', textTransform: 'uppercase', position: 'absolute', lineHeight: '13px' };
    const percentageStyle = { color: '#000', fontSize: '9px', fontWeight: '700', fontFamily: 'Helvetica, sans-serif', position: 'absolute', lineHeight: '13px' };

    const diagramSize = 180;
    const headLength = 12;
    const headWidth = 8;
    const centerOffsetX = diagramSize / 2;
    const centerOffsetY = diagramSize / 2;
    const quadrantOffsetX = centerOffsetX / 2;
    const quadrantOffsetY = centerOffsetY / 2;

    const quadrantCenters = {
      strategic: { x: quadrantOffsetX, y: quadrantOffsetY },
      performance: { x: diagramSize - quadrantOffsetX, y: quadrantOffsetY },
      visionary: { x: quadrantOffsetX, y: diagramSize - quadrantOffsetY },
      collaborative: { x: diagramSize - quadrantOffsetX, y: diagramSize - quadrantOffsetY }
    };

    const quadrantScores = [
      { name: 'strategic', score: scores?.find(s => s.name === 'strategic')?.value || 0 },
      { name: 'performance', score: scores?.find(s => s.name === 'performance')?.value || 0 },
      { name: 'visionary', score: scores?.find(s => s.name === 'visionary')?.value || 0 },
      { name: 'collaborative', score: scores?.find(s => s.name === 'collaborative')?.value || 0 }
    ];

    const sortedQuadrants = applyFullTieOrder(
      [...quadrantScores].sort((a, b) => b.score - a.score),
      (q) => q.name,
      (q) => q.score
    ).map(({ name, score }) => ({
      name: name.charAt(0).toUpperCase() + name.slice(1),
      value: score
    }));

    const pathPoints = sortedQuadrants.map(step => quadrantCenters[step.name.toLowerCase()]);

    let arrowPath = '';
    if (pathPoints.length > 0) {
      const pointsForPath = [...pathPoints];
      if (pointsForPath.length > 1) {
        const tip = pointsForPath[pointsForPath.length - 1];
        const prev = pointsForPath[pointsForPath.length - 2];
        const dx = tip.x - prev.x;
        const dy = tip.y - prev.y;
        const len = Math.hypot(dx, dy) || 1;
        const trimmedTip = {
          x: tip.x - (headLength * dx) / len,
          y: tip.y - (headLength * dy) / len
        };
        pointsForPath[pointsForPath.length - 1] = trimmedTip;
      }

      arrowPath = `M ${pointsForPath[0].x} ${pointsForPath[0].y}`;
      for (let i = 1; i < pointsForPath.length; i++) {
        arrowPath += ` L ${pointsForPath[i].x} ${pointsForPath[i].y}`;
      }
    }

    const dotPosition = sortedQuadrants[0]
      ? quadrantCenters[sortedQuadrants[0].name.toLowerCase()]
      : { x: 0, y: 0 };

    const arrowColor = '#B6111F';
    let arrowHeadPoints = '';

    if (sortedQuadrants.length > 1) {
      const lastIdx = sortedQuadrants.length - 1;
      const tip = quadrantCenters[sortedQuadrants[lastIdx].name.toLowerCase()];
      const prev = quadrantCenters[sortedQuadrants[lastIdx - 1].name.toLowerCase()];
      const angle = Math.atan2(tip.y - prev.y, tip.x - prev.x);
      const left = {
        x: tip.x - headLength * Math.cos(angle) + headWidth * Math.sin(angle),
        y: tip.y - headLength * Math.sin(angle) - headWidth * Math.cos(angle)
      };
      const right = {
        x: tip.x - headLength * Math.cos(angle) - headWidth * Math.sin(angle),
        y: tip.y - headLength * Math.sin(angle) + headWidth * Math.cos(angle)
      };
      arrowHeadPoints = `${tip.x},${tip.y} ${left.x},${left.y} ${right.x},${right.y}`;
    }

    return (
      <div style={{ position: 'relative', width: `${diagramSize}px`, height: `${diagramSize}px`, backgroundColor: 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid #000' }}>

        <div style={{ ...labelStyle, top: '6px', left: '5px' }}>
          {topLeft}
        </div>
        <div style={{ ...labelStyle, top: '6px', right: '5px' }}>
          {topRight}
        </div>

        <div style={{ ...percentageStyle, top: '20px', left: '5px' }}>
          {topLeftValue}%
        </div>

        <div style={{ ...percentageStyle, top: '20px', right: '5px' }}>
          {topRightValue}%
        </div>

        <div style={{ ...percentageStyle, bottom: '20px', left: '5px' }}>
          {bottomLeftValue}%
        </div>
        <div style={{ ...labelStyle, bottom: '6px', left: '5px' }}>
          {bottomLeft}
        </div>

        <div style={{ ...percentageStyle, bottom: '20px', right: '5px' }}>
          {bottomRightValue}%
        </div>
        <div style={{ ...labelStyle, bottom: '6px', right: '5px' }}>
          {bottomRight}
        </div>

        <div style={{ position: 'absolute', width: '2px', height: '100%', backgroundColor: '#000' }}></div>
        <div style={{ position: 'absolute', width: '100%', height: '2px', backgroundColor: '#000' }}></div>

        <svg width={diagramSize} height={diagramSize} style={{ position: 'absolute', top: 0, left: 0 }}>
          <circle cx={dotPosition.x} cy={dotPosition.y} r="6.5" fill={arrowColor} />
          <path
            d={arrowPath}
            stroke={arrowColor}
            strokeWidth="4"
            strokeOpacity="1"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          {arrowHeadPoints && (
            <polygon points={arrowHeadPoints} fill={arrowColor} stroke={arrowColor} />
          )}
        </svg>
      </div>
    );
  };

  const Arrow = () => (
    <svg width="70" height="28" viewBox="0 0 70 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
      <line x1="0" y1="12" x2="70" y2="12" stroke="#245775" strokeWidth="3.6" />
      <path d="M30 3L40 12L30 21" fill="none" stroke="#245775" strokeWidth="3.6" />
    </svg>

  );

  const getFlowText = (scores) => {
    if (!scores || scores.length === 0) return "YOU FLOW FROM";

    const priority = { strategic: 4, performance: 3, visionary: 2, collaborative: 1 };

    const sorted = [...scores]
      .map((s) => ({ name: String(s.name).toLowerCase(), value: Number(s.value) || 0 }))
      .sort((a, b) => {
        const diff = b.value - a.value;
        if (diff !== 0) return diff;
        return (priority[b.name] || 0) - (priority[a.name] || 0);
      });

    const first = (sorted[0]?.name || "strategic").toUpperCase();
    const second = (sorted[1]?.name || "performance").toUpperCase();

    return `YOU FLOW FROM ${first} TO ${second}`;
  };



  const normalize = useCallback((arr) => {
    if (!Array.isArray(arr)) return [];
    return arr
      .map((el) => ({
        name: String(el?.name || "").toLowerCase(),
        value: Number(el?.avg ?? el?.value ?? 0),
      }))
      .filter((el) => ["strategic", "performance", "visionary", "collaborative"].includes(el.name));
  }, []);

  const FlowData = useMemo(() => {
    const data = normalize(averagePercentagesLeadershipSelf || []);
    const mustHave = ["strategic", "performance", "visionary", "collaborative"];
    mustHave.forEach((n) => {
      if (!data.find((d) => d.name === n)) data.push({ name: n, value: 0 });
    });
    return data;
  }, [averagePercentagesLeadershipSelf, normalize]);

  const aggregated360FlowData = useMemo(() => {
    const data = normalize(averagePercentagesLeadership || []);
    const mustHave = ["strategic", "performance", "visionary", "collaborative"];
    mustHave.forEach((n) => {
      if (!data.find((d) => d.name === n)) data.push({ name: n, value: 0 });
    });
    return data;
  }, [averagePercentagesLeadership, normalize]);



  const imagesMap = {
    Collaborative: { icon: collaborativelogo, label: "Collaborative" },
    Strategic: { icon: stratrgiclogo, label: "Strategic" },
    Visionary: { icon: visionarylogo, label: "Visionary" },
    Performance: { icon: performancelogo, label: "Performance" },
  };

  const sortedScores = applyFullTieOrder(averagePercentagesLeadershipSelf?.slice().sort((a, b) => b.avg - a.avg), (el) => el.name, (el) => el.avg)?.map((el) => { return { name: el.name, value: el.avg } })
  const sortedImages = sortedScores?.map(item => imagesMap[item.name]);

  const sortedScores360 = applyFullTieOrder(averagePercentagesLeadership?.slice().sort((a, b) => b.avg - a.avg), (el) => el.name, (el) => el.avg)?.map((el) => { return { name: el.name, value: el.avg } })
  const sortedImages360 = sortedScores360?.map(item => imagesMap[item.name]);


  const baseSize = 88;
  const sizeDecrement = 30;
  const sizeSequence = [88, 64, 50, 28];
  const minSize = sizeSequence[sizeSequence.length - 1];
  const imageSizes = sortedImages.map((_, index) =>
    sizeSequence[index] || Math.max(minSize, baseSize - index * sizeDecrement)
  );
  const itemWidth = Math.max(...imageSizes) + 20;

  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", paddingTop: "16px" }}>
        {/* SELF */}
        <div style={{ textAlign: "center", display: "flex", justifyContent: "start", alignItems: "start", flexDirection: "column", width: "180px" }}>
          <h4 style={{ color: "#00577D", margin: "0 0 8px 0px", fontFamily: "Helvetica", fontSize: "10px", fontWeight: 700, width: "180px", lineHeight: "14px" }}> SELF </h4>
          <SquareWithArrow scores={FlowData} />
          {/* <p style={{ fontSize: "10px", color: "#00577D", marginTop: "8px", fontFamily: "Helvetica", lineHeight: "14px", fontWeight: 700 }}> {getFlowText(FlowData)} </p> */}
        </div>

        <div style={{ borderLeft: "1px solid #000000", height: "180px", alignSelf: "center", marginTop: "27px" }} />

        {/* 360 */}
        <div style={{ textAlign: "center", display: "flex", justifyContent: "start", alignItems: "start", flexDirection: "column", width: "180px" }}>
          <h4 style={{ color: "#00577D", margin: "0 0 8px 0px", fontFamily: "Helvetica", fontSize: "10px", fontWeight: 700, width: "180px", lineHeight: "14px" }}>360</h4>
          <SquareWithArrow scores={aggregated360FlowData} />
          {/* <p style={{ fontSize: '10px', color: '#00577D', marginTop: '8px', fontFamily: "Helvetica", lineHeight: "14px", fontWeight: 700 }}>{getFlowText(aggregated360FlowData)}</p> */}
        </div>
      </div>

      <div className='three60-heart-to-soul-container' style={{paddingTop:"16px"}}>
        <div className="three60-flow-bar-wrapper" style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "421px",
        }} >
          <h2 className="three60-flow-start-heading">Your Leadership Flow - Self is:</h2>
          <p style={{
            position: "absolute",
            left: "10%",
            transform: "translateX(-50%)",
            top: "8%",
            fontSize: '10px',
            fontWeight: 700,
            color: '#245775',
            fontFamily: 'Helvetica',
            margin: 0,
            marginBottom: '8px'
          }}>Start</p>
          <div className="three60-flow-image-bar" style={{
            width: "100%",
            maxWidth: "421px",
            display: 'flex',
            flexDirection: "row",
            gap: "57px",
            alignItems: "center",
            justifyContent: "center"
          }}>
            {sortedImages?.map((item, index) => (
              <div key={index} className="three60-flow-image-group"
                style={{
                  display: 'flex',
                  flexDirection: "column",
                  alignItems: "center",
                  position: "relative",
                  width: `${itemWidth}px`,
                  // width: index === sortedImages.length - 1 ? `${imageSizes[index]}px` : `${imageSizes[index] + 140}px`
                }} >
                <img
                  src={item.icon}
                  alt={item.label}
                  style={{ width: `${imageSizes[index]}px`, height: `${imageSizes[index]}px`, zIndex:"9999" }}
                />
                {index < sortedImages?.length - 1 && (
                  <div style={{
                    position: "absolute",
                    top: `${imageSizes[index] / 2}px`,
                    left: index === 0
                      ? "88px"
                      : index === 1
                        ? "61.5px"
                        : index === 2
                          ? "48px"
                          : "0px",
                    width: index == 2
                      ? "82px" : "74px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <span style={{
                      position: "absolute",
                      fontSize: 50,
                      fontWeight: 300,
                      top: -30,
                      left: 0,
                      color: "#245775",
                      fontFamily: 'Helvetica'
                    }}>
                      <Arrow />
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div style={{
            width: "100%",
            display: 'flex',
            flexDirection: "row",
            gap: "60px",
            alignItems: "center",
            justifyContent: "start"
          }}>
            {sortedImages.map((item, index) => (
              <div key={index} style={{
                display: 'flex',
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                width: `${imageSizes[index]}px`,
              }}>
                <div style={{
                marginTop: '5px',
                  textAlign: 'center',
                  width: `${imageSizes[index]}px`,
                  minWidth: "fit-content",
                }}>
                  <p style={{
                    margin: 0,
                    lineHeight: '14px',
                    fontWeight: 700,
                    fontSize: '10px',
                    color: '#245775',
                    fontFamily: 'Helvetica'
                  }}>{item.label}</p>
                  <p style={{
                    margin: 0,
                    fontSize: '10px',
                    color: '#5795B2',
                    fontWeight: 400,
                    textAlign: 'center',
                    lineHeight: '14px',
                    fontFamily: 'Helvetica'
                  }}>{typeof sortedScores[index].value === 'number' ? parseFloat(sortedScores[index].value) : parseFloat(sortedScores[index].value)}%</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "421px",
          paddingTop:"20px"
        }} className="three60-flow-bar-wrapper">
          <h2 className="three60-flow-start-heading" style={{marginBottom:"10px"}}>Your Leadership Flow - 360 is:</h2>
          <p style={{
            position: "absolute",
            left: "10%",
            transform: "translateX(-50%)",
            top: "20%",
            fontSize: '10px',
            fontWeight: 700,
            color: '#245775',
            fontFamily: 'Helvetica',
            margin: 0,
            marginBottom: '8px'
          }}>Start</p>
          <div className="three60-flow-image-bar" style={{
            width: "100%",
            maxWidth: "421px",
            display: 'flex',
            flexDirection: "row",
            gap: "57px",
            alignItems: "center",
            justifyContent: "center"
          }}>
            {sortedImages360?.map((item, index) => (
              <div key={index} className="three60-flow-image-group"
                style={{
                  display: 'flex',
                  flexDirection: "column",
                  alignItems: "center",
                  position: "relative",
                  width: `${itemWidth}px`,
                  // width: index === sortedImages.length - 1 ? `${imageSizes[index]}px` : `${imageSizes[index] + 140}px`
                }} >
                <img
                  src={item.icon}
                  alt={item.label}
                  style={{ width: `${imageSizes[index]}px`, height: `${imageSizes[index]}px`, zIndex: "9999" }}
                />
                {index < sortedImages360?.length - 1 && (
                  <div style={{
                    position: "absolute",
                    top: `${imageSizes[index] / 2}px`,
                    left: index === 0
                      ? "81px"
                      : index === 1
                        ? "61.5px"
                        : index === 2
                          ? "48px"
                          : "0px",
                    width: index == 2
                      ? "82px" : "74px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <span style={{
                      position: "absolute",
                      fontSize: 50,
                      fontWeight: 300,
                      top: -30,
                      left: 0,
                      color: "#245775",
                      fontFamily: 'Helvetica'
                    }}>
                      <Arrow />
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div style={{
            width: "100%",
            display: 'flex',
            flexDirection: "row",
            gap: "60px",
            alignItems: "center",
            justifyContent: "start"
          }}>
            {sortedImages360.map((item, index) => (
              <div key={index} style={{
                display: 'flex',
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                width: `${imageSizes[index]}px`,
              }}>
                <div style={{
                marginTop: '5px',
                  textAlign: 'center',
                  width: `${imageSizes[index]}px`,
                  minWidth: "fit-content",
                }}>
                  <p style={{
                    margin: 0,
                    lineHeight: '14px',
                    fontWeight: 700,
                    fontSize: '10px',
                    color: '#245775',
                    fontFamily: 'Helvetica'
                  }}>{item.label}</p>
                  <p style={{
                    margin: 0,
                    fontSize: '10px',
                    color: '#5795B2',
                    fontWeight: 400,
                    textAlign: 'center',
                    lineHeight: '14px',
                    fontFamily: 'Helvetica'
                  }}>{typeof sortedScores360[index].value === 'number' ? parseFloat(sortedScores360[index].value) : parseFloat(sortedScores360[index].value)}%</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default LeadershipFlowSecondPreview360;
